import { render } from "./ARight.vue?vue&type=template&id=347fc0fc"
import script from "./ARight.vue?vue&type=script&lang=js"
export * from "./ARight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__